export const phoneData = [
  {
    brand: "es.device_support.0.brand",
    models: [
      'iPhone XR',
      'iPhone XS',
      'iPhone XS Max',
      'iPhone 11',
      'iPhone 11 Pro',
      'iPhone 11 Pro Max',
      'iPhone SE (2nd generation)',
      'iPhone 12',
      'iPhone 12 mini',
      'iPhone 12 Pro',
      'iPhone 12 Pro Max',
      'iPhone 13',
      'iPhone 13 mini',
      'iPhone 13 Pro',
      'iPhone 13 Pro Max',
      'iPhone 14',
      'iPhone 14 Plus',
      'iPhone 14 Pro',
      'iPhone 14 Pro Max',
      'iPhone 15',
      'iPhone 15 Plus',
      'iPhone 15 Pro',
      'iPhone 15 Pro Max',
      'iPad Pro (3rd generation và các thế hệ sau)',
      'iPad Air (3rd generation và các thế hệ sau)',
      'iPad (7th generation và các thế hệ sau)',
      'iPad mini (5th generation và các thế hệ sau)',
      'Apple Watch Series 3 Cellular và các model sau',
    ],
    notes: [
      "es.device_support.0.notes.0",
      "es.device_support.0.notes.1",
    ],
  },
  {
    brand: "es.device_support.1.brand",
    models: [
      'Galaxy S20',
      'Galaxy S20+',
      'Galaxy S20 Ultra',
      'Galaxy S21',
      'Galaxy S21+',
      'Galaxy S21 Ultra',
      'Galaxy S22',
      'Galaxy S22+',
      'Galaxy S22 Ultra',
      'Galaxy S23',
      'Galaxy S23+',
      'Galaxy S23 Ultra',
      'Galaxy S24',
      'Galaxy S24+',
      'Galaxy S24 Ultra',
      'Galaxy Note 20',
      'Galaxy Note 20 Ultra',
      'Galaxy Z Fold 2',
      'Galaxy Z Fold 3',
      'Galaxy Z Fold 4',
      'Galaxy Z Flip',
      'Galaxy Z Flip 3',
      'Galaxy Z Flip 4',
      'Galaxy Z Flip 5',
      'Galaxy Watch 3 LTE',
      'Galaxy Watch 4 LTE',
      'Galaxy Watch 5 LTE',
    ],
    notes: [
      "es.device_support.1.notes.0",
      "es.device_support.1.notes.1",
    ],
  },
  {
    brand: "es.device_support.2.brand",
    models: [
      'Pixel 3',
      'Pixel 3 XL',
      'Pixel 3a',
      'Pixel 3a XL',
      'Pixel 4',
      'Pixel 4 XL',
      'Pixel 4a',
      'Pixel 4a 5G',
      'Pixel 5',
      'Pixel 5a',
      'Pixel 6',
      'Pixel 6 Pro',
      'Pixel 6a',
      'Pixel 7',
      'Pixel 7 Pro',
      'Pixel 7a',
      'Pixel 8',
      'Pixel 8 Pro',
    ],
    notes: [
      "es.device_support.2.notes.0",
    ],
  },
  {
    brand: "es.device_support.3.brand",
    models: [
      'Razr (2019)',
      'Razr 5G',
      'Razr 40',
      'Razr 40 Ultra',
      'Edge 20 Pro',
      'Edge 30 Pro',
      'Edge+',
      'Edge 30 Ultra',
      'Edge 40 Pro',
    ],
    notes: [],
  },
  {
    brand: "es.device_support.4.brand",
    models: [
      'P40',
      'P40 Pro',
      'P40 Pro+',
      'Mate 40 Pro',
      'Mate 40 Pro+',
      'P50',
      'P50 Pro',
      'Mate 50',
      'Mate 50 Pro',
      'P60 Pro',
      'Mate X2',
      'Mate Xs',
      'Watch 2 Pro',
      'Watch 3 Pro',
    ],
    notes: [
      "es.device_support.4.notes.0",
      "es.device_support.4.notes.1",
    ],
  },
  {
    brand: "es.device_support.5.brand",
    models: [
      'Mi 10',
      'Mi 10 Pro',
      'Mi 10T Pro',
      'Mi 11',
      'Mi 11 Ultra',
      'Mi 11i',
      '12',
      '12 Pro',
      '12 Ultra',
      '13',
      '13 Pro',
      '13 Ultra',
    ],
    notes: [],
  },
  {
    brand: "es.device_support.6.brand",
    models: [
      'Find X3 Pro',
      'Find X5',
      'Find X5 Pro',
      'Find X6 Pro',
      'Reno 5 Pro+ 5G',
      'Reno 6 Pro+ 5G',
      'Reno 7 Pro 5G',
      'Reno 8 Pro 5G',
    ],
    notes: [],
  },
  {
    brand: "es.device_support.7.brand",
    models: [
      '9',
      '9 Pro',
      '10 Pro',
      '10T',
      '11',
      '11 Pro',
      'Nord 2',
    ],
    notes: [],
  },
  {
    brand: "es.device_support.8.brand",
    models: [
      'Microsoft Surface Pro X',
      'Microsoft Surface Duo',
      "es.device_support.8.models.2",
      "es.device_support.8.models.3",
      'Dell Latitude 9510',
      'Dell Latitude 7410',
      'HP Elite Dragonfly',
      'HP Spectre x360 14',
      'Acer TravelMate P6',
      'Acer Swift 3',
    ],
    notes: [
      "es.device_support.8.notes.0",
    ],
  },
]